import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import type { UserSummary } from '../types/user-contracts.types'

/**
 * DTO de réponse pour un résumé utilisateur (informations minimales)
 */
export class UserSummaryDto implements UserSummary {
  @ApiProperty({ description: 'ID utilisateur' })
  id!: string

  @ApiPropertyOptional({ description: 'Nom affiché', nullable: true })
  displayName!: string | null

  @ApiPropertyOptional({ description: 'Email utilisateur', nullable: true })
  email!: string | null

  @ApiPropertyOptional({ description: 'URL avatar', nullable: true })
  avatarUrl!: string | null
}